import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { fetchTeamMemberList } from '@pepper/utils/src/api/users/users'

interface Parameter {
  companyId: string
}

async function handleApiRequest({
  companyId
}: Parameter): Promise<TeamMembers[]> {
  const result = await fetchTeamMemberList({ id: companyId })
  if (result.status !== 'ok') {
    throw result.error
  }
  return result.data
}

export function useGetTeamMembers({
  companyId
}: Parameter): UseQueryResult<TeamMembers[]> {
  return useQuery({
    queryKey: ['team-members', companyId],
    queryFn: () => handleApiRequest({ companyId })
  })
}
